import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Reaction.css";

const ReactionLogin = () => {
  const navigate = useNavigate();

  const [hasAccess, setHasAccess] = useState(null);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");

  /* ================= ACCESS CHECK ================= */
  useEffect(() => {
    const authed = localStorage.getItem("rg_auth") === "1";

    if (!authed) {
      navigate("/dashboard-login");
      return;
    }

    const storedEmail = localStorage.getItem("rg_email");

    if (!storedEmail) {
      navigate("/");
      return;
    }

    setEmail(storedEmail);

    axios
      .get(`/check-access?email=${storedEmail}&test=hand_eye_response_time`)
      .then(res => {
        if (res.data.allowed) {
          setHasAccess(true);
        } else {
          setHasAccess(false);
        }
      })
      .catch(() => navigate("/"));
  }, [navigate]);

  /* ================= LOGIN ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email || !phone) {
      setError("Please enter both email and phone number.");
      return;
    }

    try {
      const res = await axios.post("/auth/whitelist-login", {
        email: email.trim(),
        password: phone.trim(),
      });

      if (res.data?.ok) {
        localStorage.setItem("rg_email", email.trim());
        localStorage.setItem("rg_phone", phone.trim());
        localStorage.setItem("rg_auth", "1");

        navigate("/reactiongamev2/play");
      } else {
        setError("Access restricted. Please purchase to continue.");
      }
    } catch (err) {
      const reason = err?.response?.data?.reason;
      const base =
        err?.response?.data?.error ||
        "Access restricted. Please purchase to continue.";
      const detail = reason ? ` (Reason: ${reason})` : "";
      setError(base + detail);
    }
  };

  /* ================= LOADING ================= */
  if (hasAccess === null) {
    return <div>Loading...</div>;
  }

  /* ================= ACCESS DENIED ================= */
  if (hasAccess === false) {
    return (
      <div className="access-denied-container">
        <h2>🚫 Access Denied</h2>
        <p>You don’t have access to this test</p>
        <button onClick={() => navigate("/")}>Go Back</button>
      </div>
    );
  }

  /* ================= MAIN UI ================= */
  return (
    <div className="rg-login-wrapper">

      {/* HEADER */}
      <div className="reaction-header-card">

        <h2 className="reaction-title">Hand-Eye Response Time</h2>

        <p className="reaction-subtitle">
          This test measures how fast you respond to visual stimuli.
          It trains your brain to <strong>See → React → Execute.</strong>
        </p>

        <div className="reaction-pill">
          Test type: <strong>Visual stimulus → Multi-response</strong>
        </div>

        <hr className="reaction-divider" />

        {/* WHY */}
        <div className="reaction-why-card">

          <h3 className="why-title">Why reaction speed matters</h3>

          <p className="why-description">
            Faster reaction improves performance in sports, gaming,
            driving, and decision making under pressure.
          </p>

          <div className="why-tags">
            <span>Faster response</span>
            <span>Better coordination</span>
            <span>Quick decision making</span>
            <span>Improved focus</span>
          </div>

        </div>

      </div>

      {/* HOW */}
      <div className="how-card">

        <h2 className="how-title">How the game works</h2>

        <ul className="how-list">
          <li>Click the ball as soon as it appears</li>
          <li>Each click measures your reaction time</li>
          <li>20 attempts will be recorded</li>
          <li>Try to react as fast as possible</li>
        </ul>

        <p className="how-note">
          Tip: Stay focused and keep your hand ready.
        </p>

      </div>

      {/* START */}
      <div className="game-containerr" style={{ textAlign: "center" }}>

        <h2>Ready to Test Your Reaction?</h2>

        <p>Click Start and react as fast as possible.</p>

        <button
          onClick={() => navigate("/hand-eye-resoponsetime/play")}
          className="start-buttonr"
        >
          Start Game
        </button>

      </div>

    </div>
  );
};

export default ReactionLogin;